enum HttpStatusCodes {
  BAD_REQUEST = 400,
  PAYMENT_REQUIRED = 402,
  DUPLICATE_ENTRY = 409,
  FORBIDDEN = 403,
  INTERNAL_SERVER_ERROR = 500,
  UNPROCESSABLE_ENTITY = 422,
}

export default HttpStatusCodes;
